import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";

const Breadcrumbs = (props) => {
  return (
    <div>
      {props.data.breadCrumbs.map(({ name, path, params, icon, displayLabel, customIcon, iconColor }, key) => (
        key + 1 === props.data.breadCrumbs.length ? (
          <>
            <span key={key} className="active-crumb-name">
              {key !== 0 ?
                <span>
                  <small> &gt; </small>
                </span> : null
              }
              <span className="active-crumb-link">
                <small>{name}</small>
              </span>
            </span>
          </>
        ) : (
          <>
            <Link className="crumb-name" key={key} to={params && props.data.id ? `${path}/${props.data.id}` : path}>
              {key !== 0 ?
                <span>
                  <small> &gt; </small>
                </span> : null
              }
              <span className="crumb-link">
                {
                  (icon && !displayLabel) ?
                    <small>
                      {
                        customIcon ?
                          <Icon icon={icon} color={iconColor} />
                          :
                          <i className={icon} />
                      }
                    </small>
                    :
                    (icon && displayLabel) ?
                      <>
                        <small>
                          {
                            customIcon ?
                              <Icon icon={icon} color={iconColor} />
                              :
                              <i className={icon} />
                          }
                        </small>
                        &nbsp;
                        <small>{name}</small>
                      </>
                      :
                      <small>{name}</small>
                }
              </span>
            </Link>
          </>
        )
      )
      )}
    </div>
  )
}

export default Breadcrumbs